// extracted by mini-css-extract-plugin
export default {"tabs":"index_tabs_eF-vB","current":"index_current_J1Xcf","item":"index_item_ypdC-","dot":"index_dot_C-cqe","hairlines":"index_hairlines_6uJ-F"};